import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { MyListInventoryComponent } from './my-list-inventory/my-list-inventory.component';
import { IUserEvents } from 'src/app/models/user-events';
import { IInventory } from 'src/app/state-management/states/aumye-dashboard.state';
import { UserRegDetails } from 'src/app/models/user';
import { environment } from 'src/app/environments/environments';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-floating-icon',
  templateUrl: './floating-icon.component.html',
  styleUrls: ['./floating-icon.component.scss'],
})
export class FloatingIconComponent implements OnInit {
  isNative: boolean;
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  @Input() orgEvents: IUserEvents[];
  @Input() usersList: UserRegDetails[];
  @Input() vendorRequests: ComplaintsTickets[];
  // @Input() inventoryList: IInventory[];
  @Input() set inventoryList(val: IInventory[]) {
    this.userInventoryList = val;
  }
  @Output() onGetInventoryList = new EventEmitter();
  @Output() onClickNoticeBoard = new EventEmitter();
  @Output() onClickedManageVisitorPass = new EventEmitter();
  @Output() onClickedSaveUserInventory = new EventEmitter();
  @Output() onClickedRaiseRequest = new EventEmitter();
  @Output() onClickedVisitorLogbook = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {}
  disabledOrgIds: string[] = [];
  isDisableFeature: boolean = false;
  OrgId: string = null;
  ngOnInit(): void {
    this.isNative = Capacitor.isNativePlatform();
    this.OrgId = this.encryptionService
      .getCurrentUser()
      .organizationID?.toLowerCase();
    this.onGetInventoryList.emit();
    this.disabledOrgIds = environment.printerAllowed;
    this.isDisableFeature = this.disabledOrgIds
      .map((id) => id.toLowerCase())
      .includes(this.OrgId);
  }
  isDialogData: any;
  userInventoryList: IInventory[] = [];
  isMenuOpen: boolean = false;
  screenInfo: ScreenType = ScreenType.Desktop;
  ScreenType = ScreenType;
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onMenuItemClick(item: string) {
    console.log(`Clicked on ${item}`);
  }
  clickedNoticeBoard() {
    this.onClickNoticeBoard.emit();
  }
  clickedManageVisitorPass() {
    this.onClickedManageVisitorPass.emit();
  }
  clickedRaiseRequest() {
    this.onClickedRaiseRequest.emit();
  }
  clickedVisitorLogbook() {
    this.onClickedVisitorLogbook.emit();
  }
  clickedMyLists() {
    this.isDialogData = {
      orgEvents: this.orgEvents,
      orgVendorRequests: this.vendorRequests,
      userInventory: this.userInventoryList,
      users: this.usersList,
    };
    const dialogRef = this.dialog.open(MyListInventoryComponent, {
      disableClose: true,
      data: this.isDialogData,
    });
    dialogRef.componentInstance.onSaveUserList.subscribe((data: any) => {
      this.onClickedSaveUserInventory.emit(data);
    });
    // dialogRef.componentInstance.inventoryFormData.subscribe((data: any) => {
    //   data.close();
    // });
  }
}
